import { useEffect } from 'react'
import { treeify } from '../../../common/Helpers';
import { getElements } from '../../../services/sKPI/board.service';

const useGetBusinessElementListByType = (elementTypeId, elementArray, setElementArray,  isPanelOpen, fieldnameCode, fieldnameName) => {    
    useEffect(()=> {
        const getData = async () => {
            try {

                let serviceResponse = await getElements(elementTypeId);
                let response = serviceResponse.data.data;


                response.forEach(element => {
                    element.name = element[fieldnameName].replace("\r\n", "");
                    element.code = element[fieldnameCode];
                });


                serviceResponse = treeify(response !== null ? response : [], 'id', "parentId", null, 'code', 'name')

                setElementArray && setElementArray(serviceResponse);
            }
            catch (error) {
            }
        }
        
        if (elementTypeId !== null && elementArray === null && isPanelOpen) {
            getData()
        }

    }, [elementTypeId, elementArray, setElementArray, isPanelOpen, fieldnameCode, fieldnameName]);
}

export {
    useGetBusinessElementListByType
}